import { render, staticRenderFns } from "./SchoolFacialStaffAvailableTable.vue?vue&type=template&id=1f577ea8&scoped=true&"
import script from "./SchoolFacialStaffAvailableTable.vue?vue&type=script&lang=js&"
export * from "./SchoolFacialStaffAvailableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f577ea8",
  null
  
)

export default component.exports